import React from 'react';
import { motion } from 'framer-motion';
import { FileTextIcon } from 'lucide-react';
const HERO_IMG = 'https://cdn.magicpatterns.com/uploads/i9PUCK4ciWvjiydbHtcGr6/Isologo_azul.png';
export function Hero() {
  return <section id="top" className="relative flex min-h-screen w-full overflow-hidden bg-[#071C3D]" data-id="element-99" data-mp="9ll8gva8vumg">
      <div className="absolute inset-0" aria-hidden="true" data-id="element-100" data-mp="4n1kyqg06arz">
        <img src={HERO_IMG} alt="" className="h-full w-full object-cover opacity-90" data-id="element-101" data-mp="1297a3xzwwp6o" />
        <div className="absolute inset-0 bg-[#071C3D]/55" data-id="element-102" data-mp="xae8b2tzmmmc" />
      </div>

      <div className="relative z-10 flex w-full flex-col justify-between px-6 pb-8 pt-44 lg:px-10 lg:pb-10 lg:pt-32" data-id="element-103" data-mp="xb5rfe6eervq">
        <motion.div initial={{
        opacity: 0,
        y: 26
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.75,
        ease: [0.22, 1, 0.36, 1]
      }} className="relative mx-auto w-full max-w-7xl" data-id="element-104" data-mp="sd4d16jx3gql">
          <p className="mb-7 text-xs font-medium uppercase tracking-[0.25em] text-vm-muted" data-id="element-105" data-mp="3825y4q50c7ld">
            Tecnología visual en movimiento
          </p>

          <h1 className="max-w-full font-raleway text-[clamp(37px,10.5vw,48px)] font-extrabold uppercase leading-[1.05] tracking-[-0.04em] text-white lg:text-[clamp(68px,6vw,96px)] lg:leading-[1.11]" data-id="element-106" data-mp="3j6fw9kdl53b7">
            <span className="block" data-id="element-107" data-mp="39cpcutwbfj2d">Creamos historias</span>
            <span className="block text-[clamp(34px,9.5vw,44px)] tracking-[-0.03em] lg:text-[clamp(62px,5.5vw,88px)]" data-id="element-108" data-mp="3e84orgarj4w5">que conectan</span>
            <span className="block text-[clamp(34px,9.5vw,44px)] tracking-[-0.03em] text-vm-cream lg:text-[clamp(62px,5.5vw,88px)]" data-id="element-109" data-mp="30fybq32wpe0x">marcas <span className="text-white" data-id="element-110" data-mp="2qk3m2o09mion">con</span></span>
            <span className="block text-[clamp(34px,9.5vw,44px)] tracking-[-0.03em] text-vm-cream lg:text-[clamp(62px,5.5vw,88px)]" data-id="element-111" data-mp="2qloea6z3xpjc">personas</span>
          </h1>

          <a href="#contacto" className="mt-9 inline-flex items-center gap-3 rounded-2xl bg-vm-sky px-7 py-4 text-sm font-semibold uppercase tracking-[0.1em] text-vm-bg shadow-lg shadow-black/20 transition-all duration-200 hover:-translate-y-0.5 hover:bg-vm-cream focus:outline-none focus-visible:ring-2 focus-visible:ring-vm-sky focus-visible:ring-offset-4 focus-visible:ring-offset-vm-bg" data-id="element-112" data-mp="2hix4eblvr1tt">
            <FileTextIcon className="h-5 w-5" aria-hidden="true" data-id="element-113" data-mp="icrmolzp4d74" />
            Conversemos tu proyecto
          </a>
        </motion.div>

        <div className="mx-auto mt-10 flex w-full max-w-7xl items-center justify-between border-t border-white/20 pt-5 text-[10px] font-medium uppercase tracking-[0.25em] text-vm-muted sm:text-xs" data-id="element-114" data-mp="1b0vv3f9nj4di">
          <span data-id="element-115" data-mp="112pud0zl04a8">Vivo Media</span>
          <span data-id="element-116" data-mp="111y9ak3m1oy7">Desde Uruguay</span>
        </div>
      </div>
    </section>;
}